$(document).ready(function(){
 
//       var checkoutButton = $('[name="checkout-route-1"]');

//       if (checkoutButton.length > 0) {
       
//         checkoutButton.click();
//       }
  

   const hidebtn = setInterval(custinhd, 1000);

  // When the 'checkout' button is clicked, trigger a click on 'checkout-route-1'
  $("[name='checkout']").on('click', function() {
    $("[name='checkout-route-1']").click();
  });

  function custinhd() {
    $("body .container.max-w-screen-900 .aiod_cart_loaded[name='checkout']").show();
    $(".Customevent.aiod_cart_loaded[name='checkout-route-1']").hide();
  }

  function myStopFunction() {
    clearInterval(hidebtn);
  }

 



var title =$('.line-earth-only.decoration-earth .collectionCapture').attr('captuture');
  $('[data-handle="'+title+'"]').removeClass('hiddenS').siblings().addClass('hiddenS');
  $(".inproductsize ").click(function(){
  $(".Cmsize").hide(); $(".insize").show();
});

$(".cmroductsizes ").click(function(){
  $(".Cmsize").show();$(".insize").hide();
});

$('.text').on('click', function(e) {
  e.preventDefault();
  $('.MainSizeChart').addClass('visible');
});

$('.SizeCross').on('click', function(e){
e.preventDefault();
  $('.MainSizeChart').removeClass('visible');
})  


// $('.{ 'decoration-earth': product === '{{ product.title }}' }').on('click', function(e){
// e.preventDefault();
//   $('.line-earth-only').toggleClass('decoration-earth');
  
// })

  
  $(".womenpro ").click(function(){
  $(".Men_collectionsize").hide(); $(".Women_collectionzsize").show();
});

$(".menpro").click(function(){
  $(".Men_collectionsize").show();$(".Women_collectionzsize").hide();
});

//   $(".decoration-earth").click(function () {
//   $("#container").append('<div class="module_holder"><div class="module_item"><img src="images/i-5.png" alt="Sweep Stakes"><br>sendSMS</div></div>');
// });




  
  
});






$(document).on("click", ".collectionCapture",function(e){
  e.preventDefault();
  var title = $(this).attr('captuture');
  $('[data-handle="'+title+'"]').removeClass('hiddenS').siblings().addClass('hiddenS');
});

$(document).on("click", ".text",function(e){
  e.preventDefault();
  $("body").addClass('Sizepopup');
})

$(document).on("click", ".SizeCross",function(e){
  e.preventDefault();
  $("body").removeClass('Sizepopup');
})

// $(".line-earth-only").click(function (e) {
//  e.preventDefault();
// // $(this).attr("product_id");
// $(".Sizeswrapper").attr( "product_id" ,"{{product.variants.first.id}}");    
    
//     });


// $(".line-earth-only").parent().on("click",".line-earth-only", function () {
//     //window.alert("im changing id to btn2 and ho ho ho");
//     $(".line-earth-only").attr("product_id", "sizeproduct_id");   
// });
// $(".Sizeswrapper").parent().on("click",".Sizeswrapper",function () {
//    // window.alert("im changing id to btn1 and hey hey");
//     $(".Sizeswrapper").attr("sizeproduct_id", "product_id");    
// });

// });
// $('[product_id="{{product.variants.first.id}}"]').each(function () {
//       console.log('Previous Id attribute: ' + $(this).attr('product_id'));
//       $(this).attr('product_id', $(this).attr('product_id').replace('-', '----'));
//       console.log('Now Id Attribute: ' + $(this).attr('product_id'));
//    });

